import { ReactComponent as SadBopOutline } from "../../img/404/sadbop_outline.svg";
import { ReactComponent as SadBopFace } from "../../img/404/sadbop_face.svg";
import styled from "@emotion/styled";

export const SadBopStatic = () => {
  return (
    <Container>
      <SadBopOutline />
      <SadBopFaceStatic />
    </Container>
  );
};

// Sub-components

const Container = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  margin: 0.5rem 0 1.5rem;

  @media (min-width: 412px) {
    transform: scale(1.2);
  }
`;

const SadBopFaceStatic = styled(SadBopFace)`
  position: absolute;
  top: 32%;
`;
